<!--<div>Address Group</div>-->
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField id="ctlLine1"
                                [label]="addressLine1Label"
                                [text]="address.addressLine1"
                                [validators]="line1Validators"
                                [blurnotify]="blurnotify"
                                (blur)="onBlur()"
                                [disabled]="disabled"
                                maxlength="40"
                                (onValueChange)="updateAddress('addressLine1',$event)">
            </ValidatedTextField>
        </div>
    </div>
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField id="ctlLine2"
                                [label]="addressLine2Label"
                                [text]="address.addressLine2"
                                [validators]="line2Validators"
                                (blur)="onBlur()"
                                [disabled]="disabled"
                                maxlength="40"
                                (onValueChange)="updateAddress('addressLine2',$event)">
            </ValidatedTextField>
        </div>
    </div>

    <div class="col-8">
        <div class="input-wrapper">
            <span *ngIf="!allowPOBoxes">
                <ValidatedCheckbox class="centered-checkbox"
                                   [id]="'po-box-ovveride'"
                                   [label]="'P.O. Box Override'"
                                   [checked]="address.poboxoverride"
                                   [disabled]="disabled"
                                   (onValueChange)="poboxChange($event)">
                </ValidatedCheckbox>
            </span>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField [label]="'City'"
                                [text]="address.city"
                                [validators]="[notBlankValidator]"
                                (blur)="onBlur()"
                                [disabled]="disabled"
                                maxlength="40"
                                (onValueChange)="updateAddress('city', $event)">
            </ValidatedTextField>
        </div>
    </div>
    <div class="col-5">
        <div class="input-wrapper wide">
            <ValidatedDropDown [selectedValue]="address.state"
                               [label]="'State'"
                               [disabled]="disabled"
                               (onValueChange)="updateAddress('state',$event)"
                               [options]="states"
                               (blur)="onBlur()">
            </ValidatedDropDown>
        </div>
    </div>

    <div class="col-3">
        <div class="input-wrapper">
            <span>
                <ValidatedTextField [label]="'Zip'"
                                    [text]="address.zip"
                                    [validators]="[]"
                                    (blur)="onBlur()"
                                    [disabled]="disabled"
                                    [maxlength]="5"
                                    (onValueChange)="updateAddress('zip', $event)">
                </ValidatedTextField>
            </span>
            <span *ngIf="showZip4">
                &nbsp;-&nbsp;
                <ValidatedTextField [label]="'Zip4'"
                                    [text]="address.zip4"
                                    [validators]="[zip4CodeValidator, numericValidator]"
                                    (blur)="onBlur()"
                                    [disabled]="disabled"
                                    (onValueChange)="updateAddress('zip4', $event)">
                </ValidatedTextField>
            </span>
        </div>
    </div>
</div>
<ErrorMessages [errorMessages]="errorMessages"></ErrorMessages>